import { Picture, Video } from '@vk-tech/mark-ui';
import { MouseEvent } from 'react';

import { Popup } from '~components/Popup/Popup';
import { useUiActions } from '~hooks/useUiActions';
import { DatasetActionValues } from '~types/Dataset.types';

import styles from './PopupPicture.module.scss';
import { PopupPictureCommonProps } from './PopupPicture.types';

export function PopupPicture({
  isVisibleButtonClose = true,
  url,
  target,
  apiAction,
  image,
  video,
  active,
  popupMod,
  mod,
  opaque,
  scrollLock,
  onClose,
  onTargetAction,
  isOverlayClose,
}: PopupPictureCommonProps) {
  const { handleAction } = useUiActions();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    const targetAction = apiAction?.['target-action'];
    if (targetAction && onTargetAction) {
      onTargetAction(targetAction, true, {
        ymEvent: apiAction?.['data-ui-ym-event'],
        tmrEvent: apiAction?.['data-ui-tmr-event'],
      });
    }
    const uiAction = apiAction?.['data-ui-action'] as DatasetActionValues;
    if (uiAction) handleAction(uiAction, e.currentTarget);
    onClose?.();
  };

  const dataAttributes = Object.fromEntries(
    Object.entries(apiAction || {}).filter(([k]) => k !== 'target-action'),
  );

  return (
    <Popup
      active={active}
      isVisibleButtonClose={isVisibleButtonClose}
      onClose={onClose}
      popupMod={popupMod}
      mod={mod}
      opaque={opaque}
      scrollLock={scrollLock}
      isOverlayClose={isOverlayClose}
    >
      <a href={url} target={target} onClick={handleClick} {...dataAttributes}>
        <div className={styles.media}>
          {image?.src && <Picture {...image} className={styles.content} />}
          {video && (
            <Video
              {...video}
              autoPlay
              muted
              loop
              playsInline
              className={styles.video}
            />
          )}
        </div>
      </a>
    </Popup>
  );
}
